import performanceRulesList from "./performanceRulesList.vue";
import allEdit from "./allEdit.vue";
import performanceRuleInfo from "./performanceRuleInfo.vue"
import engineerRuleEdit from "./engineerRuleEdit.vue"

let a = Object.assign({ performanceRulesList, allEdit, performanceRuleInfo, engineerRuleEdit });
export default a;